import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        margin: theme.spacing(2, 0),
      },
      headline: {
        flex: 'auto',
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 700,
        fontSize: 21,
        lineHeight: '34px',
        color: sicrediColor.secondarySicrediDarker,
        textTransform: 'uppercase',
      },
      statusPautas: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      },
      statusPautasIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        borderRadius: '50%',
        marginRight: theme.spacing(2),
      },
      statusPautaIconWarning: {
        backgroundColor: sicrediColor.warningSicrediLight,
        color: sicrediColor.warningSicrediDark,
      },
      pautaTitle: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
          marginTop: '1rem',
        },
      },
      pautasCaption: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'left',
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 16,
        color: sicrediColor.secondarySicredi,
        borderTop: `1px solid ${sicrediColor.secondarySicredi}`,
        borderBottom: `1px solid ${sicrediColor.secondarySicredi}`,
        lineHeight: '32px',
        padding: theme.spacing(0, 1),
        margin: theme.spacing(1, 0, 2),
        '& svg': {
          width: 20,
          height: 20,
          margin: theme.spacing(0, 1, 0, 2),
        },
      },
      tabPautaInfo: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontWeight: 700,
        fontSize: 15,
        color: sicrediColor.secondarySicrediDarker,
        '& > svg': {
          width: 20,
          height: 20,
          color: sicrediColor.primarySicredi,
          margin: theme.spacing('auto', 1),
        },
      },
      paginacao: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
      },
      paginacaoPrev: {
        width: 16,
        height: 16,
        transform: 'rotate(90deg)',
      },
      paginacaoNext: {
        width: 16,
        height: 16,
        transform: 'rotate(-90deg)',
      },
      paginacaoNumber: {
        minWidth: 'unset',
      },
      flagIcon: {
        width: 20,
        height: 20,
        color: sicrediColor.secondarySicredi,
        margin: theme.spacing('auto', 1, 'auto', 0),
      },
      title: {
        flex: 'auto',
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 700,
        fontSize: 16,
        paddingRight: theme.typography.pxToRem(15),
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      anexos: {
        paddingTop: '12px',
      },
      chips: {
        display: 'flex',
        flexShrink: 0,
        // margin: theme.spacing(0, 2),
        [theme.breakpoints.down('sm')]: {
          marginLeft: '-12px',
        },
      },
      chip: {
        pointerEvents: 'none',
        '&.MuiChip-colorPrimary.Mui-disabled': {
          backgroundColor: sicrediColor.dangerSicrediLight,
          color: sicrediColor.dangerSicrediDark,
          '& > .MuiChip-iconColorPrimary': {
            color: sicrediColor.dangerSicrediDark,
          },
        },
      },
      timer: {
        backgroundColor: 'transparent',
        marginRight: 12,
      },
      direcionamento: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '24px',
        borderBottomWidth: 1,
        borderBottomColor: sicrediColor.secondarySicrediLight,
        borderBottomStyle: 'dashed',
      },
      item: {
        fontSize: 14,
        lineHeight: '24px',
        borderBottomWidth: 1,
        borderBottomColor: sicrediColor.secondarySicrediLight,
        borderBottomStyle: 'dashed',
        marginTop: theme.spacing(2),
        maxWidth: 'unset',
        display: 'flex',
        '& .MuiButton-root': {
          flexShrink: 0,
        },
      },
      labelRadio: {
        flex: 'auto',
        whiteSpace: 'normal',
      },
      acoes: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '0 -4px',
        '@media (max-width: 768px)': {
          justifyContent: 'center',
        },
        '@media (max-width: 550px)': {
          flexDirection: 'column',
        },
      },
      botaoAcoes: {
        margin: '0 4px',
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          margin: '4px 0',
        },
      },
      botaoVotoPresencial: {
        backgroundColor: sicrediColor.primarySicrediLight,
        color: sicrediColor.primarySicrediDark,
      },
      botaoEditar: {
        margin: '0 4px',
        '@media (max-width: 768px)': {
          flex: 1,
        },
        '@media (max-width: 550px)': {
          margin: '4px 0',
          width: '100%',
        },
      },
      botaoDeletar: {
        backgroundColor: '#e60000',
        margin: '0 4px',
        '@media (max-width: 768px)': {
          flex: 1,
        },
        '@media (max-width: 550px)': {
          margin: '4px 0',
          width: '100%',
        },
        '&:hover': {
          backgroundColor: '#d21818',
        },
      },
      buttonEleicao: {
        float: 'right',
        color: '#D7E6C8',
        [theme.breakpoints.down('sm')]: {
          width: '30%',
        },
      },
      buttonEleicaoAssociado: {
        float: 'right',
        color: '#D7E6C8',
        width: '20%',
        [theme.breakpoints.down('sm')]: {
          width: '30%',
        },
      },
      iconButton: {
        [theme.breakpoints.down('sm')]: {
          width: '35%',
        },
      },
      textButtonEleicao: {
        color: '#33820D',
        fontSize: '12px',
        marginLeft: '5px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '10px',
        },
      },
      descriptonStyle: {
        wordBreak: 'break-word',
      },
    }),
  { name: 'AssessorPautas' }
);
